/* eslint-disable @typescript-eslint/no-explicit-any */
import { all } from "redux-saga/effects";
import AuthSaga from "./auth/sagas";
import ConfiguracaoSaga from "./configuracao/sagas";
import LicenciamentoUrbanoSaga from "./licenciamentourbano/sagas";
import MapaSaga from "./mapa/sagas";
import servicosSaga from "./servicos/sagas";
import ZoonoseSaga from "./zoonose/sagas";
import IdentidadeSaga from "./identidade/sagas";
import ConsultaPreviaSaga from "./consultaprevia/sagas";
import OuvidoriaSaga from "./ouvidoria/sagas";

export default function* rootSaga(): any {
  return yield all([
    AuthSaga,
    MapaSaga,
    ConfiguracaoSaga,
    ZoonoseSaga,
    LicenciamentoUrbanoSaga,
    servicosSaga,
    IdentidadeSaga,
    ConsultaPreviaSaga,
    OuvidoriaSaga
  ]);
}
